<div class="flex flex-wrap">
  <div class="relative w-full xl:w-5/12 authBackground">
    <app-carousel></app-carousel>
  </div>

  <div class="relative w-full xl:w-7/12">
    <div class="login-card">
      <div class="login-main">
        <form action="#">
          <app-stepper>
            <!-- STEP 1 - OTP -->
            <cdk-step label="OTP">
              <app-forgot-password-credentials-step
                [portal]="portal()"
                [loginMethod]="loginMethod()"
                (send)="onCredentialsSubmitted($event)"
              ></app-forgot-password-credentials-step>
            </cdk-step>

            <!-- STEP 2 - VERIFY -->
            <cdk-step label="VERIFY">
              @if (username()) {
              <app-otp
                [channelValue]="username()"
                [channelType]="channelType()"
                [webBackend]="false"
                (goBack)="navigateBack()"
                (verified)="onVerified($event)"
              ></app-otp>
              }
            </cdk-step>

            <!-- STEP 3 - PIN -->
            @if (loginType() === 'pin') {
            <cdk-step label="RESET">
              <app-forgot-password-pin-step (pinSubmit)="onResetPassword($event)"></app-forgot-password-pin-step>
            </cdk-step>
            } @else {
            <!-- STEP 3 - PASSWORD -->
            <cdk-step label="RESET">
              <app-forgot-password-password-step
                (passwordSubmit)="onResetPassword($event)"
              ></app-forgot-password-password-step>
            </cdk-step>
            }
          </app-stepper>
        </form>
      </div>
    </div>
  </div>
</div>
